// import { Link } from 'react-router-dom'

export default function NavLink(props: { link: string; content: string; className?: string }) {
  return (
    <a href={props.link} className={props.className}>
      <p className='font-bold text-black-600 hover:text-blue-700 mx-2 pt-1 tracking-wide'>
        {props.content}
      </p>
    </a>
  )
}
